import React, { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import Layout from '../Layout';
import { HeaderSection, AddExpenseModal, EditExpenseModal, ViewExpenseModal } from './AccountComponent';
import { ExpenseApi } from '../../app/api/expense.api';
import { formatDateTime } from '../orders/OrderComponent';


export function Expenses() 
{
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const [month, setMonth] = useState("");

  
  const expenses = ExpenseApi(); 
  const [filteredData, setFilteredData] = useState([]);
    
  const fetchData = async () => { 
    const {data} = await expenses.findAll();
    return data.data; 
  }
  const { isLoading, data=[], error, refetch } = useQuery({  queryKey: ["expenses"], queryFn: fetchData });
    
  useEffect(() => {
      
    if (!Array.isArray(data)) return;
    let filtered = data;
      
    // Filtre mois (format YYYY-MM)
    if (month !== "") {
      filtered = filtered.filter(item =>
        item.createdAt?.startsWith(month)
      );
    }

    setFilteredData(filtered);
    
  }, [data, month]);  
  


  // MODAL HANDLER

  const handleOpenEdit = (expense) => {
    setSelectedExpense(expense);
    setShowEditModal(true);
  };

  const handleOpenView = (expense) => {
    setSelectedExpense(expense);
    setShowViewModal(true);
  };


  return (

    <Layout activeMenu={4}>
  
      <div className='container-fluid'>
        <div className='row justify-content-center pt-4'>
          <div className='col-md-11'>
                
            <div className='row' >
              <HeaderSection active={2} />
            </div>

            <section className='row'> 
                <div className="d-flex gap-2 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                   {/* Vue Grille/Liste */}
                   <div className="d-flex align-items-center gap-3 display-controls">
                     <span className="text-muted lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                     <span className="text-muted lead"> Liste des dépenses </span>
                   </div>
                    {/* Infos et Tris */}
                   <div className="d-flex align-items-center">
                      <span className="text-muted small"> { filteredData.length } effectif(s) </span>
                   </div>
                   <button title="Ajouter un produit" className="btn btn-sm btn-outline-green px-3" onClick={() => setShowAddModal(true)}>
                     <i className="bi bi-plus-circle me-1"> </i> Nouvelle dépense
                   </button>
                </div>

                {/* Boutons de Filtres Catégories */}
                <div className="d-flex gap-2 flex-wrap mb-5">
                  <div className="d-flex align-items-center">
                    <span className="text-muted px-3 bg-light border py-1"> <i className="bi bi-funnel"> </i> </span>
                    <input type="month" className="w-100 px-3 py-1 border text-muted" name="month" onChange={ e =>  setMonth(e.target.value) } />                
                  </div>
                </div>
            </section>

            <section className="row mb-4">
            
              {/* Loading */}
              {isLoading && (
                <div className="d-flex flex-column align-items-center mt-4">
                  <div className="spinner-border mb-3" style={{ width: '5rem', height: '5rem', color: '#307072' }}></div>
                  <p className="text-secondary"> Chargement de données en cours...</p>
                </div>
              )}

              {/* Error */}
              {!isLoading && error && (
               <div className="text-center p-4 border alert alert-danger w-100">
                 Une erreur est survenue. Veuillez vérifier votre connexion.
               </div>
              )}


              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (

                  filteredData.map( ( item, index ) => (

                    <div className="col-lg-12 px-0" key={index}>
                        <div className="d-flex gap-3 p-3 bg-light flex-column flex-lg-row justify-content-between border mb-3">
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center justify-content-center text-secondary me-3 p-2 bg-light border rounded">
                                <i className="bi bi-cash-stack lead"> </i> 
                            </div>
                            <div>
                              <div className="d-flex align-items-center text-secondary gap-2" >
                                <span className="" title={ 'Type de dépense' }> Type : { item?.type } </span>  
                                {
                                    item.admin !== null && ( <i className='bi bi-arrow-repeat text-green small'  title={ 'Dépense modifiée' }> </i> )
                                } 
                              </div>
                              <div className="fw-bold text-secondary" title={ 'Montant de la dépense' }> Montant : { item?.amount } Fcfa </div>
                              <div className="text-secondary small" title={ 'date' }> { formatDateTime( item?.createdAt ) } </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                             <button title="Modifier une dépense" className="btn btn-sm rounded-0 btn-outline-dark px-2 mt-2" onClick={() => handleOpenView(item)}>
                               Ouvrir <i className="bi bi-box-arrow-up-right"> </i> 
                             </button>

                             <button title="Modifier une dépense" className="btn btn-sm rounded-0 btn-outline-green px-2 mt-2" onClick={() => handleOpenEdit(item)}>
                              Modifier <i className="bi bi-pencil"> </i> 
                             </button>
                          </div>

                        </div>
                    </div>
                 ))
             )}
              {/* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}
            </section>

          </div>   
        </div>
      </div>

      <AddExpenseModal 
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        refetch={ refetch }
      />

      <EditExpenseModal 
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        expense={selectedExpense}
        refetch={ refetch }
      />

      <ViewExpenseModal 
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        expense={selectedExpense}
      />

    </Layout>

  );
        
}